import React from "react";
import "./Subsidiaries.css";

const subsidiaries = [
  {
    name: "Strides Marine & Offshore Services",
    type: "Marine operations",
    description:
      "Provides marine logistics, offshore support and vessel operations that keep field activity moving with efficiency, safety and discipline.",
  },
  {
    name: "Strides Energy Infrastructure Ltd.",
    type: "Energy infrastructure",
    description:
      "Focuses on facility construction, installation and rehabilitation across critical oil and gas infrastructure projects in demanding environments.",
  },
  {
    name: "Strides Industrial Services Co.",
    type: "Industrial support",
    description:
      "Supports industrial asset performance through maintenance, technical services and engineered solutions for high-demand operational settings.",
  },
  {
    name: "Strides Maritime Logistics",
    type: "Logistics & supply",
    description:
      "Coordinates movement of equipment, materials and marine resources to maintain continuity across offshore and coastal operations.",
  },
];

function Subsidiaries() {
  return (
    <main className="subsidiaries-page">
      <section className="subsidiaries-hero">
        <div className="subsidiaries-hero-overlay" />

        <div className="subsidiaries-container subsidiaries-hero-content">
          <span className="subsidiaries-label">Subsidiaries & Affiliates</span>

          <h1>
            Strategic business platforms
            <br />
            <span>built for growth.</span>
          </h1>

          <p>
            Our subsidiaries and affiliates extend Strides’ reach across energy,
            maritime, logistics and industrial support, enabling coordinated
            delivery across high-value projects.
          </p>
        </div>
      </section>

      <section className="subsidiaries-overview section-light">
        <div className="subsidiaries-container">
          <div className="section-heading">
            <span className="subsidiaries-label">Our network</span>
            <h2>
              Connected platforms
              <br />
              <span>driving operational strength.</span>
            </h2>
          </div>

          <div className="subsidiaries-grid">
            {subsidiaries.map((item, index) => (
              <article className="subsidiary-card" key={item.name}>
                <span className="subsidiary-index">0{index + 1}</span>
                <h3>{item.name}</h3>
                <span className="subsidiary-type">{item.type}</span>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="subsidiaries-principles">
        <div className="subsidiaries-container">
          <div className="section-heading centered">
            <span className="subsidiaries-label">Why it matters</span>
            <h2>
              One vision, <span>multiple delivery engines.</span>
            </h2>
          </div>

          <div className="subsidiaries-principles-grid">
            <div className="subsidiary-principle">
              <h3>Integrated Delivery</h3>
              <p>
                Our affiliated structures allow us to coordinate expertise,
                assets and execution capability across multiple project types.
              </p>
            </div>

            <div className="subsidiary-principle dark-card">
              <h3>Operational Agility</h3>
              <p>
                Independent business units remain focused while sharing the same
                standards, ethics and performance culture as the parent group.
              </p>
            </div>

            <div className="subsidiary-principle">
              <h3>Long-Term Value</h3>
              <p>
                The network supports resilience, scalability and strategic growth
                across energy, logistics and industrial markets.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Subsidiaries;
